/**
 * Ранние клиентские настройки загружаются Next.js до гидратации React.
 * Держать их тегом <script> внутри RootLayout нельзя: при клиентском рендере
 * React не исполняет такие теги и показывает предупреждение.
 */

declare global {
  interface Window {
    __frogstatEarlyNavigationInstalled?: boolean;
  }
}

try {
  if (JSON.parse(localStorage.getItem("frogstat_sidebar_v2") || "false")) {
    document.documentElement.dataset.frogstatSidebar = "collapsed";
    document.documentElement.style.setProperty("--sidebar-w", "48px");
    document.documentElement.style.setProperty("--sidebar-motion-ms", "0ms");
  }
} catch {}

try {
  if (!window.__frogstatEarlyNavigationInstalled) {
    window.__frogstatEarlyNavigationInstalled = true;
    document.addEventListener("pointerdown", event => {
      try {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (!location.pathname.startsWith("/view/") && !location.pathname.startsWith("/templates/preview/")) return;
        const target = event.target instanceof Element ? event.target : null;
        const anchor = target?.closest<HTMLAnchorElement>("a[href]");
        if (!anchor || anchor.download) return;
        const targetAttr = anchor.getAttribute("target");
        if (targetAttr && targetAttr !== "_self") return;
        const url = new URL(anchor.href, location.href);
        if (url.origin !== location.origin || url.pathname.startsWith("/view/")) return;
        const current = location.pathname + location.search;
        const next = url.pathname + url.search;
        if (next === current) return;
        event.preventDefault();
        document.documentElement.dataset.frogstatPendingPathname = url.pathname;
        location.assign(url.pathname + url.search + url.hash);
      } catch {}
    }, true);
  }
} catch {}

export {};
